import { render, staticRenderFns } from "./CommunicationPanel.vue?vue&type=template&id=db57243a&scoped=true&"
import script from "./CommunicationPanel.vue?vue&type=script&lang=js&"
export * from "./CommunicationPanel.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationPanel.vue?vue&type=style&index=0&id=db57243a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db57243a",
  null
  
)

export default component.exports